module.exports = __webpack_public_path__ + "z/brad2.eb6fda1e.jpg";